// NotificationCard.jsx — carte d'une notification + geste de swipe (révèle
// « Lu » / « Supprimer »). Tap = ouvre le modal de détail.
import React, { useRef, useState } from "react";
import { Ico, TYPES } from "./notificationsShared";

const SW = 156; // largeur des actions de swipe (2 × 78px)

export default function NotificationCard({ n, onOpen, onToggleRead, onDelete }) {
  const [tx, setTx] = useState(0);
  const g = useRef({ down: false, startX: 0, startTx: 0, drag: false, cur: 0 });

  const setOpen = (open) => { g.current.cur = open ? -SW : 0; setTx(g.current.cur); };

  const onDown = (e) => {
    g.current = { down: true, startX: e.clientX, startY: e.clientY, startTx: g.current.cur, drag: false, axis: null, cur: g.current.cur };
    try { e.currentTarget.setPointerCapture?.(e.pointerId); } catch (_) {}
  };
  const onMove = (e) => {
    const s = g.current;
    if (!s.down) return;
    const dx = e.clientX - s.startX;
    const dy = e.clientY - s.startY;
    // Verrouille la direction au 1er mouvement franc : horizontal = swipe,
    // vertical = scroll (on laisse le navigateur défiler, aucun tap).
    if (!s.axis) {
      if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
      s.axis = Math.abs(dx) > Math.abs(dy) ? "x" : "y";
    }
    if (s.axis === "y") return;       // scroll vertical → ne pas intercepter
    s.drag = true;
    let nx = s.startTx + dx;
    if (nx > 0) nx = 0;
    if (nx < -SW) nx = -SW;
    s.cur = nx;
    setTx(nx);
  };
  const onUp = () => {
    const s = g.current;
    if (!s.down) return;
    s.down = false;
    if (s.axis === "y") return;       // c'était un scroll : ni tap ni swipe
    if (!s.drag) {                    // tap franc
      if (s.cur < -4) setOpen(false); // refermer si déjà ouvert
      else onOpen(n);
      return;
    }
    setOpen(s.cur < -SW / 2);
  };
  // pointercancel = le navigateur a pris la main (scroll) → on fige l'état
  // courant sans jamais ouvrir le détail.
  const onCancel = () => {
    const s = g.current;
    if (!s.down) return;
    s.down = false;
    setOpen(s.cur < -SW / 2);
  };

  const T = TYPES[n.type];
  return (
    <div className={"nrow" + (n.removing ? " removing" : "") + (tx < -1 ? " is-open" : "")}>
      <div className="nrow__actions">
        <button className="swact swact--read" onClick={() => { setOpen(false); onToggleRead(n); }}>
          <Ico name={n.read ? "rotate-ccw" : "check"} />
          {n.read ? "Non lu" : "Lu"}
        </button>
        <button className="swact swact--del" onClick={() => { setOpen(false); onDelete(n); }}>
          <Ico name="trash-2" />Suppr.
        </button>
      </div>

      <div
        className={"ncard" + (n.read ? "" : " unread")}
        style={{ transform: `translateX(${tx}px)`, transition: g.current.down ? "none" : "transform .26s cubic-bezier(.32,.72,0,1)" }}
        onPointerDown={onDown} onPointerMove={onMove} onPointerUp={onUp} onPointerCancel={onCancel}
      >
        {!n.read && <span className="udot" />}
        <span className={"nic " + T.cls}><Ico name={T.ic} /></span>
        <div className="nmain">
          <div className="nhead">
            <div className="ntitle">{n.title}</div>
            <span className="ntime">{n.time}</span>
          </div>
          <div className="ntags">
            <span className={"tag tag--type " + T.cls}>
              <span className="dot" style={{ background: "currentColor" }} />{T.label}
            </span>
            <span className="tag tag--org">{n.org}</span>
          </div>
          {n.sourceType === "planning_event" && n.msg && (
            <div className="nbody">{n.msg}</div>
          )}
          {n.meta && n.meta.length > 0 && (
            <div className="nmeta">
              {n.meta.map((m, i) => (
                <span key={i}><Ico name={m.ic} />{m.strong ? <b>{m.t}</b> : m.t}</span>
              ))}
              {n.amount && <span className="amount"><Ico name="wallet" />{n.amount}</span>}
            </div>
          )}
        </div>
        <span className="nchev"><Ico name="chevron-right" /></span>
      </div>
    </div>
  );
}
